import { isNullOrUndefined } from "./is-null-or-undefined";

export function isWhitespaceOnly(str: string) {
  return str.length === 0 || /^\s*$/.test(str);
}

export function isNullOrWhitespace(str: string) {
  return isNullOrUndefined(str) || isWhitespaceOnly(str);
}
